// @flow
import Image from '@shared/Image';

const SielBleuLogo = ({ className }): React$Node => (
  <Image className={ className } src="siel-bleu-logo.png" alt="siel bleu logo" />
);

export default SielBleuLogo;
